module.exports = __webpack_public_path__ + "723e47a009d5db8436363ef227c6577a.svg";